/**
 * @param {object} item
 * @returns {string}
 */
export function getModelTypeByItem(item) {
    let modelType = item.model_type || item.objectID.match(/.*\\([^:]+)/)?.[1] || '';
    modelType = modelType
        .replaceAll(/\.?([A-Z])/g, function (x, y) {
            return '_' + y.toLowerCase();
        })
        .replace(/^_/, '');

    return modelType;
}
